module.exports = __webpack_public_path__ + "img/whats-app.9078527.webp";